import dayjs from 'dayjs';
import React from 'react';
import { PopoverContent, PopoverTitle } from 'react-bootstrap';
import { LedgerType } from 'src/pages/pto/types';
import './CalendarConflictWarning.css';

interface IProps {
    ledgerEntry: LedgerType;
}

const CalendarConflictWarning: React.FC<IProps> = (props) => {
    const { ledgerEntry } = props;

    return(
        <>
            <PopoverTitle as="h5" className='calendar-conflict-title'>
                Conflict Detected
            </PopoverTitle>  
            <PopoverContent className='calendar-conflict-content'>   
            {
                ledgerEntry.CalendarConflicts.map((conflictItem: any, index: number) => {
                    return(
                        <p key={index} > {conflictItem.FirstName} {conflictItem.lastName} : {dayjs.utc(conflictItem.ConflictDate).format("MM/DD/YYYY")}  </p>
                    )
                })
            }
            </PopoverContent>
        </>
    )
}
export default CalendarConflictWarning;